import styled from 'styled-components';
import { IBodyContent } from './interface';

const content = styled.div<IBodyContent>`
  display: flex;
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : 'column'};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : 'center'};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
  width: 100%;
  height: 100%;
  padding: 1.5rem;
`;

const Body = {
  Content: content,
};

export default Body;
